module.exports = __webpack_public_path__ + "img/pineapple.ebefa36f.svg";